// extracted by mini-css-extract-plugin
module.exports = {"TABLET_LARGE":"48em","IS_MOBILE":"false","IS_TABLET":"false","IS_DESKTOP":"false"};